import type { IRange } from '@fast-editor/core'
import { compareDocPos } from '@fast-editor/core'
import { ToolbarElement } from './ToolbarElement'

const linkPanelTemplate = `
<div class="toolbar-link-url-row">
  <div class="box">
    <input type="text" placeholder="link url" />
  </div>
  <div class="button close" data-name="close"></div>
</div>
<div class="toolbar-link-text-row">
  <div class="box">
    <input type="text" placeholder="link text" />
  </div>
  <div class="button done" data-name="done"></div>
</div>
`

export class ToolbarLinkElement extends ToolbarElement {
  public entryElement = document.createElement('div')
  public overlayElement: HTMLDivElement
  protected urlInput: HTMLInputElement
  protected textInput: HTMLInputElement
  protected showPanel = false
  protected cursorMode = false

  constructor(overlayContainer: HTMLDivElement, public readonly name: string) {
    super(overlayContainer)
    this.overlayElement = document.createElement('div')
    this.initDom()
    this.urlInput = this.overlayElement.querySelector('.toolbar-link-url-row input') as HTMLInputElement
    this.textInput = this.overlayElement.querySelector('.toolbar-link-text-row input') as HTMLInputElement
    this.initEvent()
  }

  public getEntryElement(): HTMLElement {
    return this.entryElement
  }

  public override setSelection(selection: IRange[]): void {
    let cursorMode = true
    for (let index = 0; index < selection.length; index++) {
      const range = selection[index]
      if (compareDocPos(range.start, range.end) !== 0) {
        cursorMode = false
        break
      }
    }
    this.cursorMode = cursorMode
    if (cursorMode) {
      this.textInput.removeAttribute('disabled')
    } else {
      this.textInput.setAttribute('disabled', 'disabled')
    }
  }

  protected initDom() {
    this.entryElement.classList.add(`toolbar-button-${this.name}`, 'toolbar-button')
    this.overlayElement.classList.add('toolbar-link-panel')
    this.overlayElement.innerHTML = linkPanelTemplate
    this.overlayContainer.appendChild(this.overlayElement)
  }

  protected initEvent() {
    this.entryElement.addEventListener('mousedown', (event) => {
      event.preventDefault()
    })
    this.overlayElement.addEventListener('mousedown', (event) => {
      if (!(event.target instanceof HTMLInputElement)) {
        event.preventDefault()
      }
    })
    this.entryElement.addEventListener('click', () => {
      if (!this.showPanel) {
        this.showOverlay()
      } else {
        this.hideOverlay()
      }
    })
    this.overlayElement.addEventListener('click', (event) => {
      const target = event.target as HTMLElement
      if (target.classList.contains('button')) {
        switch (target.dataset.name) {
          case 'done': {
            this.emit('set-link', this.urlInput.value.trim(), this.textInput.value.trim())
          }
          // eslint-disable-next-line no-fallthrough
          case 'close': {
            this.hideOverlay()
            break
          }
        }
      }
    })
  }

  protected showOverlay() {
    const overlayElementWidth = 286
    const entryElementHeight = 32
    const topOffset = 9
    const entryBounding = this.entryElement.getBoundingClientRect()
    const overlayContainerBounding = this.overlayContainer.getBoundingClientRect()

    this.showPanel = true
    this.overlayElement.style.left = `${Math.max(
      Math.min(
        entryBounding.left - overlayContainerBounding.left - overlayElementWidth / 2 + entryBounding.width / 2,
        overlayContainerBounding.width - overlayElementWidth - 5,
      ),
      5,
    )}px`
    this.overlayElement.style.top = `${
      entryBounding.top - overlayContainerBounding.top + entryElementHeight + topOffset
    }px`
    this.overlayElement.style.display = 'block'
  }

  protected hideOverlay() {
    this.showPanel = false
    this.overlayElement.style.display = 'none'
    this.urlInput.value = ''
    this.textInput.value = ''
  }
}
